/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Failed_BranchInputs */



/**
* | output |
* | --- |
* | "the submission branch could not be written" |
*
* @param {Twda_Failed_BranchInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_failed_branch = /** @type {((inputs?: Twda_Failed_BranchInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Failed_BranchInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("la branche de soumission n'a pas pu être écrite")
	if (locale === "es") return /** @type {LocalizedString} */ ("la rama de envío no se pudo escribir")
	if (locale === "pt") return /** @type {LocalizedString} */ ("a branch de envio não pôde ser escrita")
	if (locale === "it") return /** @type {LocalizedString} */ ("il branch di invio non è stato scritto")
	return /** @type {LocalizedString} */ ("the submission branch could not be written")
});